import { ethers } from "ethers";
import { ERC20ABI } from "../Ethereum/Constant/abis";

const getTokenBalance = async (tokenAddress) => {
  try {
    if (!window.ethereum) throw new Error("MetaMask not found");

    const accounts = await window.ethereum.request({ method: "eth_accounts" });

    if (accounts.length === 0) {
      console.log("MetaMask wallet not connected");
      return null;
    }

    const walletAddress = accounts[0];
    const provider = new ethers.BrowserProvider(window.ethereum);
    const contract = new ethers.Contract(tokenAddress, ERC20ABI, provider);

    const rawBalance = await contract.balanceOf(walletAddress);
    const decimals = await contract.decimals();
    const symbol = await contract.symbol();

    const balance = ethers.formatUnits(rawBalance, decimals);

    console.log(`Token Balance: ${balance} ${symbol}`);
    return balance;
  } catch (error) {
    console.error("Error fetching token balance:", error);
    return null;
  }
};

export default getTokenBalance;
